// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".course-actions[data-v-b818457e]{display:flex;flex-direction:column;gap:.75rem;margin-bottom:1rem}.course-actions__secondary[data-v-b818457e]{display:grid;gap:.5rem}.course-actions__secondary .btn[data-v-b818457e]{min-height:42px;font-weight:500}.course-actions__status[data-v-b818457e]{border-radius:.5rem;background-color:#f8f9fa}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
